(function(rm) {
    if (rm.ready) {
        return true;
    }

    var getClient = function() {
            if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(window.navigator.userAgent)) {
                return 'mobile';
            }
            return 'desktop';
        },
        client = getClient();

    var trackRebelEvent = function(action) {
        var xRequest = new XMLHttpRequest(),
            url = 'https://external-pages-stats.rbl.ms/spacer.gif?' + [
                Math.ceil(Math.random() * +new Date()),
                'event=' + action,
                'version=' + 1,
                'format=' + 'json',
                'data=' + encodeURIComponent(JSON.stringify({
                    is_external: 1,
                    referrer: window.document.referrer,
                    client: client
                }))
            ].join('&');

        xRequest.open('GET', url, true);
        xRequest.send();
    };

    rm.ready = function(onReadyCallback) {
        if (document.readyState !== 'loading') {
            onReadyCallback();
        } else {
            document.addEventListener('DOMContentLoaded', onReadyCallback);
        }
    };

    rm.ready(function() {
        trackRebelEvent('ext-page-view');

        document.querySelector('body').addEventListener('click', function() {
            trackRebelEvent('ext-page-click');
        });
    });
})(window.RMSTATS = window.RMSTATS || {});


//////////////////
// WEBPACK FOOTER
// ./assets/vendor/js/external_pages_tracker.js
// module id = 1152
// module chunks = 0